import { Bullets, Card } from '../../ui/index.js';
import { RbacMatrix } from '../rbac/RbacMatrix.js';
import type { AccessCenterProps } from './AccessCenter.js';
import styles from './Access.module.css';

/** Roles: the matrix, the summary cards, custom roles, and how the model works. */
export function RolesTab({ users, groups, roles, staffTenantId, canWrite, onChanged }: AccessCenterProps) {
  return (
    <div className={styles.stack}>
      <RbacMatrix roles={roles} groups={groups} users={users} {...(staffTenantId ? { staffTenantId } : {})} readOnly={!canWrite} onChanged={onChanged} />
      <Card title="How the model works">
        <Bullets
          items={[
            'A role is a set of levels, one per resource. There is no permission that lives outside this matrix.',
            'Full access never implies administration. Managing people is its own column, management.',
            'Every organization starts with one role, Tenant Admin, which always keeps management. You create the rest as your modules arrive.',
            'Superadmins hold full access to everything and change only through appointment, removal or handoff, each approved by a second person.',
            'Modules appear as columns as they ship, and only the ones the organization has bought are ever visible.',
          ]}
        />
      </Card>
    </div>
  );
}
